import React, { useContext, useEffect, useState, useRef } from "react";
import { fetchcustdetail } from "./Newpvinkpi";
import { FilterContext } from "../../context/Filter";

const CustomerDetailsCard = ({ data = [] }) => {
  const { childArn, superArn: ParArn } = useContext(FilterContext);

  // API & UI states
  const [custdet, setCustdet] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [error, setError] = useState(null);

  // Determine ARN dynamically
  const getDynamicArn = () => {
    if (ParArn) return { key: "parArn", value: ParArn };
    // if (childArn) return { key: "childArn", value: childArn };

    // fallback to vin from URL
    const urlParams = new URLSearchParams(window.location.search);
    const vin = urlParams.get("vin");
    if (vin) return { key: "parArn", value: vin };

    return { key: null, value: null };
  };

  const { key, value } = getDynamicArn();
  const payload = value ? { [key]: value } : null;

  const activeRequest = useRef(0);

  useEffect(() => {
    if (!value) {
      setCustdet(null);
      setError(null);
      setFetched(false);
      setLoading(false);
      return;
    }

    const reqId = ++activeRequest.current;
    setLoading(true);
    setFetched(false);
    setError(null);

    const getCustomerDetail = async () => {
      try {
        const res = await fetchcustdetail(payload);
        if (reqId !== activeRequest.current) return;

        const result = res?.data?.result || res?.result || res || null;
        setCustdet(result);
        setError(null);
      } catch (err) {
        if (reqId !== activeRequest.current) return;
        console.error("Error fetching customer details:", err);
        setCustdet(null);
        setError(err);
      } finally {
        if (reqId !== activeRequest.current) return;
        setLoading(false);
        setFetched(true);
      }
    };

    getCustomerDetail();

    return () => {
      activeRequest.current++;
    };
  }, [value]);

  const parData = custdet?.parData;
  const hasRecords = Array.isArray(parData) && parData.length > 0;
  const customer = hasRecords ? parData[0] : null;

  if (!value) {
    return (
      <CardShell title="Customer Details">
        <div className="flex items-center justify-center h-full text-gray-500 text-sm">
          No customer selected.
        </div>
      </CardShell>
    );
  }

  if (loading) {
    return (
      <CardShell title="Customer Details">
        <div className="flex justify-center items-center h-full">
          <div className="flex flex-col items-center text-gray-500">
            <div className="w-8 h-8 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin" />
            <p className="text-sm mt-2">Loading customer details...</p>
          </div>
        </div>
      </CardShell>
    );
  }

  if (fetched && error) {
    return (
      <CardShell title="Customer Details">
        <div className="flex items-center justify-center h-full text-red-500 text-sm">
          Error loading customer details.
        </div>
      </CardShell>
    );
  }

  if (fetched && !hasRecords) {
    return (
      <CardShell title="Customer Details">
        <div className="flex items-center justify-center h-full text-gray-500 text-sm">
          No customer data found.
        </div>
      </CardShell>
    );
  }

  return (
    <CardShell title="Customer Details">
      <div className="flex flex-col gap-2 mt-2">
        <Row label="Customer Name">{data?.Customer_Name ?? customer?.PAR_ACCNT_NAME ?? "N/A"}</Row>
        <Row label="Contact No" even>{customer?.PAR_ACCNT_MAIN_PH_NUM ?? "N/A"}</Row>
        <Row label="ARN">{data?.ARN ?? customer?.PAR_ACCNT_ARN ?? "N/A"}</Row>
        <Row label="KA Code" even>{data?.KA_CODE ?? customer?.KA_CODE ?? "N/A"}</Row>
      </div>
    </CardShell>
  );
};

export default CustomerDetailsCard;

const CardShell = ({ title, children }) => (
  <div className="w-[331px] h-[349px] border rounded-md flex flex-col shadow-sm">
    <p className="bg-[#056db3] rounded-t-md p-1 text-white">{title}</p>
    <div className="border" />
    <div className="flex-1 p-2">{children}</div>
  </div>
);

const Row = ({ label, children, even }) => (
  <div className={`flex items-center justify-between rounded-sm p-2 ${even ? "bg-gray-100" : ""}`}>
    <p>{label}:</p>
    <p className="font-medium text-right">{children}</p>
  </div>
);
